import cookies from 'js-cookie';
cookies.remove('code');
//cookies.remove('appid');

function getAppid() {
    const href = window.location.href;
    let appid = '';
    if(href.indexOf('hl.tf56.com') >= 0 || href.indexOf('hlwap.tf56.com') >= 0 || href.indexOf('hellogil.com') >= 0 ) {
        //生产appid
        appid = 'wx279ecb3fef5cc08d';
    }else{
        appid = 'wx279ecb3fef5cc08d';//'wx718b3fe3c2ddc6f3';//'wxa8ae37284c72d902';
    }
    return appid;
};

function getBackUrl() {
    const backUrl = window.location.href;
    return backUrl;
}


export const appid = getAppid();
export const backUrlForCode = getBackUrl();


// WEBPACK FOOTER //
// ./src/utils/constant.js